export default [
  {
    path: "/project",
    name: "project",
    component: () => import("@/views/project/index.vue"),
    meta: {
      title: "项目介绍"
    }
  }
];
